import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Menu from '@material-ui/core/Menu';
import Icon from '../../core/Icon';
import DropdownButtonContext from './Context';
import DropdownButtonEntry from './Entry';
import DropdownButtonDataList from './DataList';
import DropdownButtonDataSelect from './DataSelect';
/**
 * @extends {React.Component<import('./types').DropdownButtonProps>}
 */

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownButton, _React$Component);

  function DropdownButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropdownButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      anchorEl: null,
      open: false
    };

    _this.onOpen = function (event) {
      _this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    };

    _this.onClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.onClick = function (e, option) {
      _this.onClose();

      if (option.onClick) option.onClick(e, option);else if (_this.props.onClick) _this.props.onClick(e, option);
    };

    _this.onClickWhenNoMenu = function (e) {
      _this.onClose();

      var option = _this.props.options && _this.props.options[0];
      if (option && option.onClick) option.onClick(e, option);
    };

    return _this;
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          menuProps = _this$props.menuProps,
          showArrowIcon = _this$props.showArrowIcon,
          collapseIfSingle = _this$props.collapseIfSingle,
          onClick = _this$props.onClick,
          children = _this$props.children,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, ["options", "menuProps", "showArrowIcon", "collapseIfSingle", "onClick", "children", "style"]);

      var hasChildren = !!children;
      var hasOptions = options && (options.length > 1 ? true : collapseIfSingle ? false : true);
      var hasMenu = hasChildren || hasOptions;
      var hasArrow = hasMenu ? showArrowIcon : false;
      return React.createElement(DropdownButtonContext.Provider, {
        value: {
          onClick: this.onClick
        }
      }, React.createElement(Icon, Object.assign({
        onClick: hasMenu ? this.onOpen : this.onClickWhenNoMenu,
        endAdornment: hasArrow ? 'down-filled' : undefined,
        style: style
      }, rest)), React.createElement(Menu, Object.assign({
        id: "dropdown-button",
        anchorEl: this.state.anchorEl,
        open: this.state.open,
        onClose: this.onClose,
        PaperProps: {
          style: {
            backgroundColor: "white"
          }
        }
      }, menuProps), hasOptions && options.map(function (option, idx) {
        return React.createElement(DropdownButtonEntry, {
          key: idx,
          option: option
        });
      }), children));
    }
  }]);

  return DropdownButton;
}(React.Component);

DropdownButton.defaultProps = {
  showArrowIcon: false,
  collapseIfSingle: false
};
DropdownButton.Entry = DropdownButtonEntry;
DropdownButton.DataList = DropdownButtonDataList;
DropdownButton.DataSelect = DropdownButtonDataSelect;
export default DropdownButton;